import {timestampToDate} from "../../../utils/date";

export const sortAuditLogs = (auditLogs) => {
  return [...auditLogs].sort((a, b) => (
    new Date(timestampToDate(b.createdAt)).getTime()
    - new Date(timestampToDate(a.createdAt)).getTime()
  ));
};
